import React from "react";

/* Approved Ponesi brand assets (ORIGINAL customer scope). The artwork lives in
   `public/brand/`, derived from the authoritative sources in `public/brand/source/` —
   never redrawn in CSS/SVG, never recoloured. `height` is applied inline (width stays auto so
   the aspect ratio is always preserved). */

// Customer header: the supplied asset already contains the "Ponesi" wordmark on brand red,
// so no separate text is rendered next to it.
export const HeaderLogo = ({ className = "", height = 44, ...rest }) => (
  <img src="/brand/ponesi-header-logo.webp?v=9" alt="Ponesi"
    style={{ height, width: "auto", display: "block" }} fetchPriority="high" decoding="async"
    className={`select-none ${className}`} draggable="false" {...rest}
    data-testid="ponesi-header-logo" />
);

// Footer / compact customer branding (the P mark, transparent canvas, on a light surface).
export const FooterLogo = ({ className = "", height = 32, ...rest }) => (
  <img src="/brand/ponesi-footer-logo.webp?v=9" alt="Ponesi"
    style={{ height, width: "auto", display: "block" }} decoding="async"
    className={`select-none ${className}`} draggable="false" {...rest}
    data-testid="ponesi-footer-logo" />
);

// ponesi.rs/b2b wordmark.
export const B2BLogo = ({ className = "", height = 56, ...rest }) => (
  <img src="/brand/ponesi-b2b-logo.webp?v=9" alt="ponesi.rs"
    style={{ height, width: "auto", display: "block" }} decoding="async"
    className={`select-none ${className}`} draggable="false" {...rest}
    data-testid="ponesi-b2b-logo" />
);
